export const material = [
    {
        id: 1,
        name: "ԱՆԴՇԱՖՏԱՅԻՆ ՆԱԽԱԳԾՈՒՄ ԵՎ ԴԻԶԱՅՆ",
        info: "Դիտել",
        file: "../../files/geography/materials/1.pdf",
        menuItemId: 6
    },
    {
        id: 2,
        name: "Աշխարհագրական մշակույթ Սխեմա",
        info: "Դիտել",
        file: "../../files/geography/materials/2.pdf",
        menuItemId: 6
    },
    {
        id: 3,
        name: "Աշխարհի բնակչության էթնոլեզվական կազմը",
        info: "Դիտել",
        file: "../../files/geography/materials/3.pdf",
        menuItemId: 6
    },
    {
        id: 4,
        name: "Աշխարհի բնակչության կրոնական և ռասայաման կազմը",
        info: "Դիտել",
        file: "../../files/geography/materials/4.pdf",
        menuItemId: 6
    },
    {
        id: 5,
        name: "ԱՇԽԱՐՀԻ ԵՐԿՐՆԵՐԻ ԽՄԲԱՎՈՐՈՒՄԸ ԵՎ ՏԻՊԱԲԱՆԱԿԱՆ ԴԱՍԱԿԱՐԳՈՒՄԸ",
        info: "Դիտել",
        file: "../../files/geography/materials/5.pdf",
        menuItemId: 6
    },
    {
        id: 6,
        name: "Աշխարհի բնակչության կրոնական և ռասայաման կազմը",
        info: "Դիտել",
        file: "../../files/geography/materials/6.pdf",
        menuItemId: 6
    },
    {
        id: 7,
        name: "Աշխարհի քաղ, քարտեզ սահիկ",
        info: "Դիտել",
        file: "../../files/geography/materials/7.pdf",
        menuItemId: 6
    },
    {
        id: 8,
        name: "Աշխարհի քաղաքական քարտեզ",
        info: "Դիտել",
        file: "../../files/geography/materials/8.pdf",
        menuItemId: 6
    },
    {
        id: 9,
        name: "Աշխարհի քաղաքական քարտեզ գործնական",
        info: "Դիտել",
        file: "../../files/geography/materials/9.pdf",
        menuItemId: 6
    },
    {
        id: 10,
        name: "ԱՇԽ․ ԵՐԿ․ ԽՄԲ․ ԵՎ ՏԻՊ․ ԴԱՍ․ գործնական",
        info: "Դիտել",
        file: "../../files/geography/materials/10.pdf",
        menuItemId: 6
    },
    {
        id: 11,
        name: "Աշխ․ ժամ․ հիմնախնդ․ Դաս 4",
        info: "Դիտել",
        file: "../../files/geography/materials/11.pdf",
        menuItemId: 6
    },
    {
        id: 12,
        name: "Աշխ․ ժամ․ հիմնախնդ․ Դաս 5",
        info: "Դիտել",
        file: "../../files/geography/materials/12.pdf",
        menuItemId: 6
    },
    {
        id: 13,
        name: "ԱՖՐԻԿԱ ԴԱՍ. 1",
        info: "Դիտել",
        file: "../../files/geography/materials/13.pdf",
        menuItemId: 6
    },
    {
        id: 14,
        name: "Աֆրիկա դաս. 2",
        info: "Դիտել",
        file: "../../files/geography/materials/14.pdf",
        menuItemId: 6
    },
    {
        id: 15,
        name: "Աֆրիկա դաս. 3",
        info: "Դիտել",
        file: "../../files/geography/materials/15.pdf",
        menuItemId: 6
    },
    {
        id: 16,
        name: "Աֆրիկա դաս. 4",
        info: "Դիտել",
        file: "../../files/geography/materials/16.pdf",
        menuItemId: 6
    },
    {
        id: 17,
        name: "Բնական պայմաններ և ռեսուրսներ, տեսակները, դասակարգումները և հայեցակարգերը",
        info: "Դիտել",
        file: "../../files/geography/materials/17.pdf",
        menuItemId: 6
    },
    {
        id: 18,
        name: "Բնական ռեսուրսների դասակարգ․",
        info: "Դիտել",
        file: "../../files/geography/materials/18.pdf",
        menuItemId: 6
    },
    {
        id: 19,
        name: "Երկիր- պետություն Պետականության հատկանիշները",
        info: "Դիտել",
        file: "../../files/geography/materials/19.pdf",
        menuItemId: 6
    },
    {
        id: 20,
        name: "ԼԱՆԴՇԱՖՏԱԳԻՏՈՒԹՅՈՒՆ։  Դաս․6",
        info: "Դիտել",
        file: "../../files/geography/materials/20.pdf",
        menuItemId: 6
    },
    {
        id: 21,
        name: "ԼԱՆԴՇԱՖՏԱԳԻՏՈՒԹՅՈՒՆ։  Դաս․7",
        info: "Դիտել",
        file: "../../files/geography/materials/21.pdf",
        menuItemId: 6
    },
    {
        id: 22,
        name: "ԼԱՆԴՇԱՖՏԱԳԻՏՈՒԹՅՈՒՆ։  ՆՈՐ Դաս․3",
        info: "Դիտել",
        file: "../../files/geography/materials/22.pdf",
        menuItemId: 6
    },
    {
        id: 23,
        name: "ԼԱՆԴՇԱՖՏԱԳԻՏՈՒԹՅՈՒՆ։  ՆՈՐ Դաս․4",
        info: "Դիտել",
        file: "../../files/geography/materials/23.pdf",
        menuItemId: 6
    },
    {
        id: 24,
        name: "ԼԱՆԴՇԱՖՏԱՅԻՆ ԴԻԶԱՅՆ",
        info: "Դիտել",
        file: "../../files/geography/materials/24.pdf",
        menuItemId: 6
    },
    {
        id: 25,
        name: "ԼԱՆԴՇԱՖՏԱՅԻՆ ՆԱԽԱԳԾՈՒՄ ԵՎ ԴԻԶԱՅՆ",
        info: "Դիտել",
        file: "../../files/geography/materials/25.pdf",
        menuItemId: 6
    },
    {
        id: 26,
        name: "Լեզվաընտանիքներ",
        info: "Դիտել",
        file: "../../files/geography/materials/26.pdf",
        menuItemId: 6
    },
    {
        id: 27,
        name: "Հայերի ծագում",
        info: "Դիտել",
        file: "../../files/geography/materials/27.pdf",
        menuItemId: 6
    },
    {
        id: 28,
        name: "Հայերի ծագումնաբանություն",
        info: "Դիտել",
        file: "../../files/geography/materials/28.pdf",
        menuItemId: 6
    },
    {
        id: 29,
        name: "Հայկական լեռնաշխարհի բնական պայմանները",
        info: "Դիտել",
        file: "../../files/geography/materials/29.pdf",
        menuItemId: 6
    },
    {
        id: 30,
        name: "Հայկական լեռնաշխարհի ֆիզիկաաշխարհագրական շրջանները",
        info: "Դիտել",
        file: "../../files/geography/materials/30.pdf",
        menuItemId: 6
    },
    {
        id: 31,
        name: "Հյուսիսային Ամերիկա, դաս 6",
        info: "Դիտել",
        file: "../../files/geography/materials/31.pdf",
        menuItemId: 6
    },
    {
        id: 32,
        name: "Հյուսիսային Ամերիկա դաս. 1",
        info: "Դիտել",
        file: "../../files/geography/materials/32.pdf",
        menuItemId: 6
    },
    {
        id: 33,
        name: "Հյուսիսային Ամերիկա դաս. 2",
        info: "Դիտել",
        file: "../../files/geography/materials/33.pdf",
        menuItemId: 6
    },
    {
        id: 34,
        name: "Հյուսիսային Ամերիկա դաս. 4",
        info: "Դիտել",
        file: "../../files/geography/materials/34.pdf",
        menuItemId: 6
    },
    {
        id: 35,
        name: "Հյուսիսային Ամերիկա դաս. 5",
        info: "Դիտել",
        file: "../../files/geography/materials/35.pdf",
        menuItemId: 6
    },
    {
        id: 36,
        name: "Հյուսիսային_Ամերիկա. Կլիման",
        info: "Դիտել",
        file: "../../files/geography/materials/36.pdf",
        menuItemId: 6
    },
    {
        id: 37,
        name: "Հնէաաշխարհագրություն Դասախոս",
        info: "Դիտել",
        file: "../../files/geography/materials/37.pdf",
        menuItemId: 6
    },
    {
        id: 38,
        name: "Մթնոլորտային ճնշում, մթնոլորտային շրջանառություն",
        info: "Դիտել",
        file: "../../files/geography/materials/38.pdf",
        menuItemId: 6
    },
    {
        id: 39,
        name: "Պետության գլխավոր քաղաքաաշխարհագրական բնութագրիչները",
        info: "Դիտել",
        file: "../../files/geography/materials/39.pdf",
        menuItemId: 6
    },
    {
        id: 40,
        name: "ՋԵՐՄԱ- ԵՎ ՋՐԱՇՐՋԱՆԱՌՈՒԹՅՈՒՆԸ ՄԹՆՈԼՈՐՏՈՒՄ",
        info: "Դիտել",
        file: "../../files/geography/materials/40.pdf",
        menuItemId: 6
    },
    {
        id: 41,
        name: "ՋՐԱՅԻՆ ՕԲՅԵԿՏՆԵՐ ԵՎ ՋՐԱԲԱՆԱԿԱՆ ՊՐՈՑԵՍՆԵՐ",
        info: "Դիտել",
        file: "../../files/geography/materials/41.pdf",
        menuItemId: 6
    },
    {
        id: 42,
        name: "Քաղաքական քարտեզ սլայդ",
        info: "Դիտել",
        file: "../../files/geography/materials/42.pdf",
        menuItemId: 6
    },




];


